import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';
import SbEditable from 'storyblok-react';
import Image from '~/components/Dynamic/Image';
import TextCard from '~/components/Dynamic/TextCard';
import chevronUp from '~/icons/chevron-up.svg';
import renderLink from '~/utils/render-link';

export default function UseCaseSlider({ blok }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [clicked, setClicked] = useState(false);
  let timeout;

  useEffect(() => {
    if (!clicked && !timeout) {
      timeout = setTimeout(() => setSelectedTab((selectedTab + 1) === blok?.slides?.length ? 0 : selectedTab + 1), 6000);
    } else {
      clearTimeout(timeout);
    }

    return () => timeout && clearTimeout(timeout);
  }, [selectedTab]);


  return (
    <section className="my-20 md:my-28">
      <div className="container">
        <div className="text-center md:flex md:text-left">
          <TextCard blok={blok?.textCard[0]} />
        </div>
        <div className="flex flex-wrap mt-12 -ml-16 md:mt-20 lg:-ml-32">
          <div className="w-full pl-16 text-center md:w-6/12 lg:pl-32">
            {blok?.slides?.map((item, i) => (
              <React.Fragment key={`image${item._uid}`}>
                {selectedTab === i && (
                  <SbEditable content={item}>
                    <AnimatePresence exitBeforeEnter>
                      <motion.div
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 10, opacity: 0 }}
                      >
                        <Image blok={item.icon} className="flex justify-center mx-auto " imageClassName="w-full" />
                      </motion.div>
                    </AnimatePresence>
                  </SbEditable>
                )}
              </React.Fragment>
            ))}
          </div>
          <div className="w-full pl-16 mt-12 space-y-4 md:space-y-8 md:w-6/12 lg:pl-32 md:mt-0" onClick={() => setClicked(true)}>

            <div className={`flex gap-8 md:hidden`}>
              {blok?.slides?.map((item, i) => (
                <div className="w-full py-6 mb-4 cursor-pointer" onClick={() => setSelectedTab(i)}>
                  <div className={`w-full h-0.5  bg-[#D3D2C6] relative overflow-hidden`} >
                    <div className={`absolute top-0 left-0 w-full h-full bg-blue transform -translate-x-full ${(!clicked && (selectedTab === i)) && 'animate-progress-x'} ${(clicked && (selectedTab === i)) && 'translate-x-0'}`} style={{animationDuration: '6s'}}></div>
                  </div>
                </div>
              ))}
            </div>

            {blok?.slides?.map((item, i) => (
              <SbEditable content={item} key={`text${item._uid}`}>
                <div
                  className={`flex flex-col max-w-[24rem] select-none cursor-pointer ${((selectedTab !== i)) && 'hidden md:block'}`}
                  onClick={() => setSelectedTab(i)}
                >
                  <div className={`md:py-4 md:pl-8 relative ${!clicked && selectedTab === i && 'border-blue'}`}>
                    <div className="h-32 w-0.5 bg-light-grey hidden md:block absolute top-1/2 transform -translate-y-1/2 left-0 overflow-hidden">
                      <div
                        className={`absolute top-0 left-0 w-full h-full bg-blue transform -translate-y-full ${
                          !clicked && selectedTab === i && 'animate-progress-y'
                        } ${clicked && selectedTab === i && 'translate-y-0'}`}
                        style={{ animationDuration: '6s' }}
                      ></div>
                    </div>
                    <div className="flex flex-col">
                      <h4 className="mb-1 font-extrabold uppercase text-20px u-h4">{item.heading}</h4>
                      <div className="text-15px">
                        <p>{item.content}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </SbEditable>
            ))}
          </div>
        </div>

        {blok?.button?.length > 0 && (
          <div className="flex justify-center mt-12 md:mt-24">
            <Link
              to={renderLink(blok?.button[0]?.button?.cached_url)}
              className="flex justify-center px-6 uppercase cursor-pointer group c-btn c-btn--outline c-btn--outline--black text-14px"
            >
              {blok?.button[0]?.title}{' '}
              <img
                src={chevronUp}
                alt=""
                className="ml-8 transition-all transform rotate-90 group-hover:filter group-hover:invert"
              />
            </Link>
          </div>
        )}
      </div>
    </section>
  );

}
